import { createRoute, redirect } from "@tanstack/react-router";
import { PhoneRuntimeBulkPromote } from "@/components/phone-runtime-bulk-promote";
import { PhoneRuntimeChangelog } from "@/components/phone-runtime-changelog";
import { Skeleton } from "@/components/ui/skeleton";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { rootRoute } from "./root-route";

export const phoneRuntimeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/phone-runtime",
  beforeLoad: async () => {
    try {
      await api.me();
    } catch {
      throw redirect({
        to: "/login",
        search: { returnTo: "/phone-runtime", error: undefined },
      });
    }
  },
  component: PhoneRuntimePage,
});

function PhoneRuntimePage() {
  const auth = useAuth();

  if (auth.status === "loading") {
    return (
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-4 w-96" />
        </div>
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (auth.status === "anon") return null;

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <h1 className="font-heading text-2xl font-semibold tracking-tight">
          手机运行时
        </h1>
        <p className="text-sm text-muted-foreground">
          升级已发布案件的手机壳，并查看各版本发布说明。
        </p>
      </div>
      <PhoneRuntimeBulkPromote />
      <PhoneRuntimeChangelog />
    </div>
  );
}
